import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Dayjs } from 'dayjs';

export class DemandUpdateDeliveryDateDialogData {
    constructor(public readonly minDate: Dayjs, public readonly initialDate?: Dayjs) {}
}

export class DemandUpdateDeliveryDateDialogResult {
    constructor(public readonly desiredDeliveryDate: Dayjs) {}
}

@Component({
    selector: 'demand-update-delivery-date-dialog',
    templateUrl: './update-delivery-date-dialog.component.html',
    standalone: false,
})
export class DemandUpdateDeliveryDateDialogComponent {
    private readonly dialogRef =
        inject<MatDialogRef<DemandUpdateDeliveryDateDialogComponent>>(MatDialogRef);
    public readonly data = inject<DemandUpdateDeliveryDateDialogData>(MAT_DIALOG_DATA);
    private readonly formBuilder = inject(FormBuilder);

    public readonly form = this.formBuilder.group({
        desiredDeliveryDate: [this.data.initialDate ?? null, [Validators.required]],
    });

    public cancel(): void {
        this.dialogRef.close();
    }

    public save(): void {
        const desiredDeliveryDate = this.form.value.desiredDeliveryDate;
        if (this.form.invalid || !desiredDeliveryDate) {
            return;
        }

        this.dialogRef.close(new DemandUpdateDeliveryDateDialogResult(desiredDeliveryDate));
    }
}
